// extracted by mini-css-extract-plugin
module.exports = {"pills":"_2dOaZT8Ek_Bw88C3ocULct"};